// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/contaminated-takeoff-reject-point.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/contaminated-takeoff-reject-point/contaminated-takeoff-reject-point.js';

mount([g0]);
